import { render } from "./SetImporteCost.vue?vue&type=template&id=2dbbb733"
import script from "./SetImporteCost.vue?vue&type=script&lang=js"
export * from "./SetImporteCost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__